module.exports = __webpack_public_path__ + "img/brasil-flag.23c03a16.svg";